import { usePage } from "@inertiajs/react"

export type Market = { id: string; slug: string; name: string; currency: string }

// Present only on market-scoped pages (shared by the MarketScoped concern).
export function useMarket(): Market {
  const market = (usePage().props as { market?: Market }).market
  if (!market) throw new Error("useMarket() outside a market-scoped page")
  return market
}

export function useMarketOrNull(): Market | null {
  return (usePage().props as { market?: Market }).market ?? null
}
